import { render, staticRenderFns } from "./ProjectAppointInfoConfirm.vue?vue&type=template&id=48384bfc&scoped=true&"
import script from "./ProjectAppointInfoConfirm.vue?vue&type=script&lang=js&"
export * from "./ProjectAppointInfoConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAppointInfoConfirm.vue?vue&type=style&index=0&id=48384bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48384bfc",
  null
  
)

export default component.exports